import { GLOBAL_UNIFORMS } from "../../shader/GlobalUniforms";
import { Uniform } from "three";
//  glslify is used for including GLSL shader code
const glslify = require("glslify");
const VERTEX_SHADER = require("./instance.vert");
const FRAGMENT_SHADER = require("./instance.frag");
const INSTANCE_VERTEX_SHADER = VERTEX_SHADER && glslify(VERTEX_SHADER);
const INSTANCE_FRAGMENT_SHADER = FRAGMENT_SHADER && glslify(FRAGMENT_SHADER);
export var LineAttributes;
(function (LineAttributes) {
    LineAttributes[LineAttributes["start_point"] = 0] = "start_point";
    LineAttributes[LineAttributes["end_point"] = 1] = "end_point";
    LineAttributes[LineAttributes["line_params"] = 2] = "line_params";
    LineAttributes[LineAttributes["color"] = 3] = "color";
})(LineAttributes || (LineAttributes = {}));
export const LINE_INSTANCE_SHADER = {
    uniforms: {
        cameraCenterWorldPosition: GLOBAL_UNIFORMS.cameraCenterWorldPosition,
        platformScale: GLOBAL_UNIFORMS.platformScale,
        // time in milliseconds
        time: GLOBAL_UNIFORMS.time,
        noiseTexture: GLOBAL_UNIFORMS.noiseTexture,
        maxEffectsDistance: new Uniform(10),
        minEffectsDistance: new Uniform(2),
        worldScale: new Uniform(0)
    },
    vertexShader: INSTANCE_VERTEX_SHADER,
    fragmentShader: INSTANCE_FRAGMENT_SHADER,
    attributes: [
        // start point of the line in room coordinates
        {
            name: "instance_start_point",
            size: 3,
            type: Float32Array,
            normalized: false
        },
        // end point of the line in room coordinates
        {
            name: "instance_end_point",
            size: 3,
            type: Float32Array,
            normalized: false
        },
        // parameters for the line (thickness, fussyness, noise_frequency, nois_velocity)
        {
            name: "instance_line_params",
            size: 4,
            type: Float32Array,
            normalized: false
        },
        // the color of the instance, normalized to 0..1
        { name: "instance_color", size: 3, type: Uint8Array, normalized: false }
    ]
};
LINE_INSTANCE_SHADER.uniforms.worldScale = GLOBAL_UNIFORMS.platformScale;
